<template>
  <div class="info-bar-wrapper" :class="{ error: error, hidden: hidden }">
    <div class="msg">{{ message }}</div>
    <div class="clear" @click="close"></div>
    <div class="one" @click="close">
      <div class="two" @click="close"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: String,
    error: {
      type: Boolean,
      default: false,
    },
    timeout: Number,
  },
  data() {
    return {
      hidden: false,
      timer: undefined,
      defaultTimeout: 5000,
    }
  },
  mounted() {
    const timeout = this.timeout ? this.timeout : this.defaultTimeout
    const _this = this
    this.timer = setTimeout(_this.close, timeout)
  },
  methods: {
    close() {
      clearTimeout(this.timer) // do not throw error if timer === undefined
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.info-bar-wrapper {
  display: flex;
  align-items: center;
  //justify-content: center;
  text-align: left;
  position: relative;
  box-shadow: 0 2px 4px 0 rgba(3, 8, 41, 0.2);

  @include fade-in-opacity;
  &.hidden {
    @include fade-out-opacity;
  }

  @include respond-below(sm) {
    width: 100%;
  }
  padding: 18px 0;
  // min-height: 57px;

  background-color: $blue;

  &.error {
    background-color: $red;
  }

  .msg {
    color: white;
    padding-left: 20px;
    @include font-rule('averta-bold');
    font-size: 16px;
    margin-right: 72px;
  }

  .clear {
    position: absolute;
    right: 22px;
    width: 28px;
    height: 28px;
    cursor: pointer;
  }

  .one {
    position: absolute;
    right: 36px;
    height: 22.5px;
    width: 1px;
    background-color: white;
    transform: rotate(45deg);
    cursor: pointer;
    &:hover {
      opacity: 0.5;
    }

    .two {
      height: 22.5px;
      width: 1px;
      background-color: white;
      transform: rotate(90deg);
    }
  }
}
</style>
